export const LOGIN_INITIALIZATION_FAILURE = 'login_initialization_failure'
